import AddBillerGroupModal from "./AddBillerGroupModal";
import AlreadyPaidBillModal from "./AlreadyPaidBillModal";
import CancelPaymentModal from "./CancelPaymentModal";
import ConfirmTurnOffEBillModal from "./ConfirmTurnOffEBillModal";
import DeleteAutoPayModal from "./DeleteAutoPayModal";
import DeleteBillerGroupModal from "./DeleteBillerGroupModal";
import EditBillerGroupModal from "./EditBillerGroupModal";
import InsufficientFundsModal from "./InsufficientFundsModal";
import MoveBillerToGroupModal from "./MoveBillerToGroupModal";
import OpenNewWindowModal from "./OpenNewWindowModal";
import TestModal from "./TestModal";
import WantToLeaveModal from "./WantToLeaveModal";

export default {
    "AddBillerGroupModal" : AddBillerGroupModal,
    "CancelPaymentModal" : CancelPaymentModal,
    "ConfirmTurnOffEBillModal" : ConfirmTurnOffEBillModal,
    "MoveBillerToGroupModal" : MoveBillerToGroupModal,
    "OpenNewWindowModal": OpenNewWindowModal,
    "TestModal" : TestModal,
    "WantToLeaveModal" : WantToLeaveModal,
    "AlreadyPaidBillModal" : AlreadyPaidBillModal,
    "DeleteBillerGroupModal" : DeleteBillerGroupModal,
    "EditBillerGroupModal" : EditBillerGroupModal,
    "InsufficientFundsModal": InsufficientFundsModal,
    "DeleteAutoPayModal": DeleteAutoPayModal,
};